import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { PropertyService } from '../service/property.service';
import { CreatePropertyCategoryComponent } from '../create-property-category/create-property-category.component';
import { DialogModule } from 'primeng/dialog';


@Component({
  selector: 'app-property-category-listing',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, DialogModule, CreatePropertyCategoryComponent],
  templateUrl: './property-category-listing.component.html',
  styleUrls: ['./property-category-listing.component.scss'],
})
export class PropertyCategoryListingComponent {
  categories: any[] = [];
  position: 'center' | 'right' = 'center';
  visible: boolean = false;

  showDialog(position: 'right'): void {
    this.position = position;
    this.visible = true;
  }
  constructor(private router: Router, private propertyService: PropertyService,) {}


  ngOnInit() {
    this.getAllPropertyCategories();
  }

  navigateToCreateCategory() {
    this.router.navigate(['/create-property-category']);
  }  

  getAllPropertyCategories() {
    this.propertyService.getAllPropertyCategories().subscribe(res => {
      if (res) {
        this.categories = res;
      }
    });
  }
}
